<template>
				<v-row
					
					align="center"
					justify="center"
                    no-gutters
                    class="links fill-height"
				>
                    <v-col 
                
                    :md="8"
                    :sm="12"
                     class="buttons"
                    
                    >
                    <v-hover v-slot:default="{ hover }">

                        <v-btn class="button " href="https://soundcloud.com/magnulh" icon>
							<v-icon  v-bind:class="[hover?'white--text':'info--text', 'icon']">mdi-soundcloud</v-icon>
						</v-btn>
                    </v-hover>
                        
			
                  <v-hover v-slot:default="{ hover }">

						<v-btn class="button" href="https://www.linkedin.com/in/magnus-lundh-haaland-b6b075150/" icon>
							<v-icon v-bind:class="[hover?'white--text':'info--text', 'icon']">mdi-linkedin</v-icon>
						</v-btn>
                    </v-hover>
                        
			
                  <v-hover v-slot:default="{ hover }">
						<v-btn class="button" href="https://github.com/magnuslh" icon>
							<v-icon v-bind:class="[hover?'white--text':'info--text', 'icon']">mdi-github</v-icon>
						</v-btn>
                 </v-hover>
                        
			
                  <v-hover v-slot:default="{ hover }">
						<v-btn  class="button" href="mailto:haaland.magnus@gmail.com" icon >
							<v-icon v-bind:class="[hover?'white--text':'info--text', 'icon']">mdi-email</v-icon>
						</v-btn>
                     </v-hover>
                    </v-col>
				
						
						
				</v-row>
					
		
   
</template>

<script>
  export default {
		name: 'Links'
	
  }
</script>

<style scoped>
.links{
    padding: 1rem; 
}
.buttons{
    display:flex; 
    flex-direction: row;
    justify-content: space-evenly;
}
.button{
    width: 2rem; 
    margin:auto; 
}
.icon{
    margin:auto;
}
</style>





